import Api from '@/services/Api'
import currencyConverter from '@/services/CurrencyConverter'
import { AppModule } from '@/shared/js/vuex/modules/app'

export default AppModule({ Api, currencyConverter })
